"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageSuccess = exports.MessageError = exports.MessageCustom = exports.ConfirmCustom = void 0;
var _elementUi = require("element-ui");
var ADD_SUCCESS_NOTICE = '添加成功';
var UPDATE_SUCCESS_NOTICE = '修改成功';
var DELETE_SUCCESS_NOTICE = '删除成功';
var SAVE_SUCCESS_NOTICE = '保存成功';
var SAVE_ERROR_NOTICE = '保存失败';
var ADD_ERROR_NOTICE = '添加失败';
var UPDATE_ERROR_NOTICE = '修改失败';
var DELETE_ERROR_NOTICE = '删除失败';

/**
 * 成功通知
 * @param type
 */
var MessageSuccess = exports.MessageSuccess = function MessageSuccess(type) {
  switch (type) {
    case 'add':
      _elementUi.Message.success({
        message: ADD_SUCCESS_NOTICE
      });
      break;
    case 'upd':
      _elementUi.Message.success({
        message: UPDATE_SUCCESS_NOTICE
      });
      break;
    case 'del':
      _elementUi.Message.success({
        message: DELETE_SUCCESS_NOTICE
      });
      break;
    case 'save':
      _elementUi.Message.success({
        message: SAVE_SUCCESS_NOTICE
      });
      break;
  }
};

/**
 * 失败通知
 * @param type
 */
var MessageError = exports.MessageError = function MessageError(type) {
  switch (type) {
    case 'add':
      _elementUi.Message.error({
        message: ADD_ERROR_NOTICE
      });
      break;
    case 'upd':
      _elementUi.Message.error({
        message: UPDATE_ERROR_NOTICE
      });
      break;
    case 'del':
      _elementUi.Message.error({
        message: DELETE_ERROR_NOTICE
      });
      break;
    case 'save':
      _elementUi.Message.error({
        message: SAVE_ERROR_NOTICE
      });
      break;
  }
};

/**
 *  自定义通知
 * @param type
 * @param message
 * @constructor
 */
var MessageCustom = exports.MessageCustom = function MessageCustom() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'info';
  var message = arguments.length > 1 ? arguments[1] : undefined;
  switch (type) {
    case 'success':
      _elementUi.Message.success({
        message: message
      });
      break;
    case 'warning':
      _elementUi.Message.warning({
        message: message
      });
      break;
    case 'info':
      _elementUi.Message.info({
        message: message
      });
      break;
    case 'error':
      _elementUi.Message.error({
        message: message
      });
      break;
  }
};
var ConfirmCustom = exports.ConfirmCustom = function ConfirmCustom() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    type: 'info'
  };
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '您确认删除所选内容吗？';
  var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '提示';
  return _elementUi.MessageBox.confirm(message, title, options);
};